import angular from 'angular';
import creditMemoDialogTemplate from './CreditMemoDialog.html';
import CSMCommonWeb from 'csm-common-web';
import booksService from '../../booksServices';

/*******************************************************************************
 * @ngdoc       service
 * @name        csm.books.WriteReceipts.service:CreditMemoDialog
 * @description
 * Dialog to create a credit memo.
 *******************************************************************************/
export default angular
  .module('csm.books.com.CreditMemoDialog', [
    CSMCommonWeb,
    'ui.bootstrap',
    booksService
  ])
  .service('CreditMemoDialog', CreditMemoDialogService).name;

/* @ngInject */ function CreditMemoDialogService(
  $uibModal,
  uiGridConstants,
  Alert
) {
  /*****************************************************************************
   * show */
  /**
   * This will display a modal dialog to create a credit memo of the selected receipt.
   *
   * @param  receivable  List of receivables
   * @return              Promise to listen on
   *****************************************************************************/
  this.show = function (receivable) {
    return $uibModal.open({
      animation: true,
      backdrop: 'static',
      resolve: {
        receivable: function () {
          return receivable;
        }
      },
      controller: creditMemoController,
      size: 'md',
      template: creditMemoDialogTemplate
    }).result;
  };

  /*****************************************************************************
   * Dialog Controller
   *****************************************************************************/
  /* @ngInject */ function creditMemoController(
    $scope,
    $timeout,
    receivable,
    AccountType,
    BusyScreen,
    BooksSvc,
    DestinyService
  ) {
    /** Validators. */ $scope.validators = {};

    /** Dialog Data. */
    $scope.data = {
      amount: receivable.balance,
      balance: receivable.balance,
      entryDate: new Date()
    };

    /***************************************************************************
     * createMemo */
    /**
     * Confirm credit request and build the Credit Memo entry and send to the
     * server.
     ***************************************************************************/
    $scope.createMemo = function () {
      if (!$scope.validators.validate()) return;

      Alert.confirm(
        'This cannot be undone. Are you sure \nyou want to apply a credit to this item?',
        'Credit Memo'
      ).then(function () {
        var errorFnc = function (resp) {
          Alert.error(
            resp.parsedResponse.message() || resp.statusText,
            'Save Error'
          );
        };

        /*----------------------------------------------------*/
        /* The source of the receivable is for Destiny fines. */
        /* So if there is a source, this is for Destiny.      */
        /* TODO: This belongs in ASB.                         */
        /*----------------------------------------------------*/
        if (receivable.source) {
          BusyScreen.promise(
            DestinyService.fineWaiver(
              receivable.source,
              $scope.data.amount,
              receivable.entityID,
              $scope.data.memo
            ).then(function (resp) {
              $scope.$close();
            }, errorFnc)
          );
        } else {
          /*--------------------*/
          /* Create memo ledger */
          /*--------------------*/
          var memo = {
            entryDate: $scope.data.entryDate,
            memo: $scope.data.memo,
            referenceID: receivable.referenceID
          };

          var creditItem = {};

          /*----------------------------------------------------------------------*/
          /* Create the main item which handles the debit for the chosen account. */
          /* Non-receipt items will get the account ID from the original item.    */
          /*----------------------------------------------------------------------*/
          creditItem.referenceItemID = receivable.referenceItemID;
          memo.itemCredit = creditItem;

          /*-----------------------*/
          /* Set common properties */
          /*-----------------------*/
          creditItem.entityID = receivable.entityID;
          creditItem.amount = $scope.data.amount;
          creditItem.memo = memo.memo;

          /*---------------*/
          /* Save the memo */
          /*---------------*/
          BusyScreen.promise(
            BooksSvc.addCreditMemo(memo).then(function (resp) {
              $scope.$close();
            }, errorFnc)
          );
        }
      });
    };

    /*--------------------------*/
    /* Load accounts to be used */
    /*--------------------------*/
    BooksSvc.getAccounts(false, [AccountType.EXPENSE, AccountType.TRUST]).then(
      function (resp) {
        $scope.accounts = resp.data;
      }
    );
  }
}
